import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal, SecurityStatement } from 'common/components/layout';
import Questions from 'profile/login/Questions';
import { getCustomer } from 'redux/customer/actions';

import ReturningCustomerForgot from './components/ReturningCustomerForgot';

class ForgotPassword extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { settings, onCloseModal, onLogin, redirectLink } = this.props;
    if (!settings.data) {
      return (
        <Modal title="Forgot Password" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }
    return (
      <Modal title="Forgot Password" onCloseModal={onCloseModal}>
        <div className="c7-account-login">
          <ReturningCustomerForgot
            onLogin={onLogin}
            redirectLink={redirectLink}
          />
        </div>
        <SecurityStatement settings={settings} />
        <Questions settings={settings} />
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { getCustomer })(ForgotPassword);
